import React from 'react'
import './InfoBlock.css'

const stats = [
  {
    value: '3000+',
    label: 'Довольных клиентов',
  },
  {
    value: '5',
    label: 'Лет на рынке',
  },
  {
    value: '20+',
    label: 'Сотрудников',
  },
]

const InfoBlock = () => {
  return (
    <section className="info-block" aria-label="Преимущества компании">
      <div className="info-block__inner">
        {stats.map((item) => (
          <article className="info-block__item" key={item.label}>
            <p className="info-block__value">{item.value}</p>
            <p className="info-block__label">{item.label}</p>
          </article>
        ))}
      </div>
    </section>
  )
}

export default InfoBlock